import TSX from "./Division";

export default TSX;
